var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_179584_4812)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6247 6.40613H3.48249L8.95437 1.65613C9.04187 1.57957 8.98874 1.43738 8.87312 1.43738H7.4903C7.42937 1.43738 7.37155 1.45925 7.32624 1.49832L1.42155 6.62175C1.36747 6.66863 1.3241 6.72659 1.29438 6.79169C1.26465 6.85679 1.24927 6.92753 1.24927 6.9991C1.24927 7.07067 1.26465 7.1414 1.29438 7.2065C1.3241 7.27161 1.36747 7.32956 1.42155 7.37644L7.36062 12.5311C7.38405 12.5514 7.41218 12.5624 7.44187 12.5624H8.87155C8.98718 12.5624 9.0403 12.4186 8.9528 12.3436L3.48249 7.59363H12.6247C12.6934 7.59363 12.7497 7.53738 12.7497 7.46863V6.53113C12.7497 6.46238 12.6934 6.40613 12.6247 6.40613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179584_4812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f6677122565e7fec87e41aa7a9709a3d.svg";
export { ForwardRef as ReactComponent };